import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeEmployeerComponentModal, fetchEmployeerComponent, openEmployeerComponentModal } from "./store/employeerComponentSlice";
import AddEmployeerComponent from "./AddEmployeerComponent";
import EmployeerComponentDataTable from "./EmployeerComponentDataTable";

const EmployeerComponent = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.employeerComponentData || {});

  useEffect(() => {
    dispatch(fetchEmployeerComponent());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee CTC "
            title="Dashboard"
            subtitle="Employee CTC"
            name="Import Employee CTC"
            onAddClick={() => dispatch(openEmployeerComponentModal())}
          />

          <EmployeerComponentDataTable data={data} loading={loading} />

          <AddEmployeerComponent
            show={isModalOpen}
            onClose={() => dispatch(closeEmployeerComponentModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeerComponent;
